<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-07-27 14:16:47
 * @LastEditors: lau
 * @LastEditTime: 2022-10-25 09:40:20
-->
<!-- 车场通道信息变更上报接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
 
        },
        responseCode: {
          "data": {},
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动上报月票变更同步信息上报到第三方接入系统",
          urlPattern: this.commonUrls.third + "reportMonthTicketSyncMessage",
          precondition: "无",
          fitSystem: "传统车场，路边车场",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          frequency: "实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',tdName: 'info1'},
			  {tableHead: '是否必填',tdName: 'info2'}
			  , {tableHead: '类型',tdName: 'info3'}
			  ,{tableHead: '说明',tdName: 'info4'
            }],
            td: [
				{
				info1: 'parkCode',info2: '是',info3: 'String',info4: '停车场编号'
				},
              {
                info1: 'id',info2: '是',info3: 'Long',info4: '同步月票信息记录id'
				},
              {
                info1: 'monthTicketConfigId',info2: '是',info3: 'Long',info4: '月票类型id'
				},
              {
                info1: 'monthTicketId',info2: '是',info3: 'Long',info4: '月票id'
              },
              {
                info1: 'carCodes',info2: '是',info3: 'Long',info4: '车牌(以,分割)'
              },
              {
                info1: 'receiveStatus',info2: '是',info3: 'Integer',info4: '下发类型(0:开通,1:续费,2:退款/取消)'
              },
              {
                info1: 'syncStatus',info2: '是',info3: 'Integer',info4: '同步状态(0未发送，1发送中，2发送成功，3发送失败)'
              }
              ,
              {
                info1: 'syncTime',info2: '是',info3: 'Integer',info4: '同步时间yyyyMMddHHmmss'
              } ,
              {
                info1: 'ticketNo',info2: '是',info3: 'String',info4: '月卡(月票)唯一编号(传统停车场，路边车场)'
              },
              {
                info1: 'resendNum',info2: '是',info3: 'String',info4: '重发次数'
              },
              {
                info1: 'userName',info2: '是',info3: 'String',info4: '车主电话'
              },
              {
                info1: 'userPhone',info2: '是',info3: 'String',info4: '车主名称'
              }

            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: []
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{
              tableHead: '状态码',
              tdName: 'info1'
            }, {
              tableHead: '说明',
              tdName: 'info2'
            }],
            td: []
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportMonthTicketSyncMessage.vue